import { getUserData } from "../hooks/getUserRole";
import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { User } from "./User";
import useOemData from "../hooks/useOemData";
import "../styles/sidebar.css";

const { Header, Content, Sider } = Layout;

const SITE_HOME_ROLES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const SideBar = ({ children, items }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { oemNo, loading: oemDataLoading } = useOemData();
  const [collapsed, setCollapsed] = useState(false);

  const userData = getUserData();
  const role_value = userData?.role_value;

  const selectedKey =
    items?.find((item) => location.pathname === item.key)?.key || "";

  const handleLogoClick = () => {
    navigate(SITE_HOME_ROLES.includes(role_value) ? "/site" : "/");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (oemDataLoading) {
    return (
      <div className="w-full flex items-center justify-center h-screen" />
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        className="border-b"
        style={{
          height: "55px",
          padding: "0px 2px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 60,
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{ cursor: "pointer", marginLeft: "16px" }}
          onClick={handleLogoClick}
        >
          <img
            src={require(`../../oem/${oemNo}/images/mainLogo.png`)}
            style={{ height: "36px" }}
            alt="Logo"
          />
        </div>
        <div className="mr-4">
          <User />
        </div>
      </Header>

      <Layout style={{ backgroundColor: "white" }}>
        <Sider
          collapsed={collapsed}
          onCollapse={setCollapsed}
          style={{
            backgroundColor: "#FEFFFF",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 55,
            bottom: 0,
            overflowY: "auto",
            zIndex: 100,
          }}
        >
          <Menu
            selectedKeys={[selectedKey]}
            mode="inline"
            items={items?.map((item) => ({
              ...item,
              icon: React.cloneElement(item.icon, {
                color: location.pathname === item.key ? "#ffffff" : "#3A3A41",
              }),
            }))}
            onClick={(item) => navigate(item?.key)}
          />
          <div
            style={{
              position: "fixed",
              top: "83px",
              left: collapsed ? 80 : 200,
              transform: "translateX(-50%)",
              padding: "10px",
              cursor: "pointer",
              zIndex: 200,
              transition: "left 0.3s ease",
            }}
            onClick={() => setCollapsed((prev) => !prev)}
          >
            <div className="bg-customColor p-[4px] rounded-full border border-white focus:!bg-none">
              {collapsed ? (
                <FaAngleRight color="#FEFFFF" size={18} />
              ) : (
                <FaAngleLeft color="#FEFFFF" size={18} />
              )}
            </div>
          </div>
        </Sider>

        <Layout
          style={{
            backgroundColor: "#F4F5F9",
            marginLeft: collapsed ? 80 : 200,
            transition: "margin-left 0.3s ease",
          }}
        >
          <Content style={{ margin: "16px 22px" }}>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
